import { LAYOUTS, } from "@voltmoney/types";
import { ROUTE } from "../../routes";
import { ACTION } from "./types";
import { editDetailsAction, goBackAction, onDownLoadEarningReport, toolTipAmplitudeEventAction } from "./actions";
import { StackType, StackWidth, WIDGET } from "@voltmoney/schema";
import { onChangeDimension } from "../cgtcInit/actions";
import sharedPropsService from "../../SharedPropsService";
import { triggerAmplitudeEventCGS } from "../cgtcInit/utils";
export const template = (height, data, phone, pan, toDate, fromDate) => ({
    layout: {
        id: ROUTE.CGTC_SUMMARY,
        type: LAYOUTS.LIST,
        style: {
            isPartnerPlatform: true,
        },
        widgets: [
            { id: 'cgtcSummaryRootContainer', type: WIDGET.STACK },
        ],
    },
    datastore: {
        cgtcSummaryRootContainer: {
            type: StackType.column,
            width: StackWidth.MATCH_PARENT,
            widgetItems: [
                { id: 'cgtcSummaryPage', type: WIDGET.CGTC_SUMMARY }
            ],
            dimensionAction: {
                type: ACTION.ON_CHANGE_DIMENSION,
                routeId: ROUTE.CGTC_SUMMARY,
                payload: {}
            }
        },
        cgtcSummaryPage: {
            show: true,
            data: data,
            editAction: {
                routeId: ROUTE.CGTC_SUMMARY,
                type: ACTION.EDIT_DETAIL,
                payload: {}
            },
            downloadAction: {
                routeId: ROUTE.CGTC_SUMMARY,
                type: ACTION.DOWNLOAD,
                payload: {}
            },
            toolTipAmplitudeEvent: {
                routeId: ROUTE.CGTC_SUMMARY,
                type: ACTION.TOOL_TIP_AMPLITUDE,
                payload: {}
            },
            pan: pan,
            phone: phone,
            toDate: toDate,
            fromDate: fromDate,
        }
    },
});
export const cgtcSummaryMF = {
    onLoad: async ({ getHeight, network, navigateToBase, instrumentTrack, removeWidgets, ...props }) => {
        await removeWidgets(ROUTE.CGTC_SUMMARY, [
            { id: 'cgtcSummaryPage', type: WIDGET.CGTC_SUMMARY }
        ]);
        const userContext = await sharedPropsService.getCgtcUserContext();
        const data = userContext?.cgsData;
        const phone = userContext?.phone;
        const pan = userContext?.pan;
        const toDate = userContext?.toDate;
        const fromDate = userContext?.fromDate;
        await triggerAmplitudeEventCGS(instrumentTrack, {
            eventName: 'CGS_SUMMARY_VIEWED'
        });
        return Promise.resolve(template(getHeight(), data, phone, pan, toDate, fromDate));
    },
    actions: {
        [ACTION.GO_BACK]: goBackAction,
        [ACTION.ON_CHANGE_DIMENSION]: onChangeDimension,
        [ACTION.EDIT_DETAIL]: editDetailsAction,
        [ACTION.DOWNLOAD]: onDownLoadEarningReport,
        [ACTION.TOOL_TIP_AMPLITUDE]: toolTipAmplitudeEventAction,
    },
    clearPrevious: true,
};
